// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2eSO3","approved":"Status_approved__BIjjt","rejected":"Status_rejected__IGR2h","expired":"Status_expired__iclOg","label":"Status_label__3khtR"};